import React from 'react';

import { WebUiButton } from '../../../components/button';
import { WebUiInput } from '../../../components/input';

export function VlanStatusPanel({
  readonly,
  enabled,
  setEnabled,
  onSet,
}: {
  readonly: boolean;
  enabled: boolean;
  setEnabled: (value: boolean) => void;
  onSet: () => void;
}) {
  return (
    <div className="flex w-full flex-col gap-2">
      <h4 className="font-bold">VLAN Status</h4>
      <table className="webui-table w-full">
        <thead>
          <tr className="webui-table-row-head">
            <th>Setting</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr className="webui-table-row-content">
            <td>VLANs enabled</td>
            <td>
              <WebUiInput
                type="checkbox"
                disabled={readonly}
                checked={enabled}
                onChange={(e) => setEnabled(e.target.checked)}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <WebUiButton onClick={onSet} disabled={readonly}>
          Set VLAN Status
        </WebUiButton>
      </div>
    </div>
  );
}

export function VlanAddIdPanel({
  readonly,
  newVid,
  setNewVid,
  newVidName,
  setNewVidName,
  onAdd,
}: {
  readonly: boolean;
  newVid: number;
  setNewVid: (value: number) => void;
  newVidName: string;
  setNewVidName: (value: string) => void;
  onAdd: () => void;
}) {
  return (
    <div className="flex w-full flex-col gap-2">
      <h4 className="font-bold">Add VLAN ID</h4>
      <table className="webui-table w-full">
        <thead>
          <tr className="webui-table-row-head">
            <th>VLAN ID</th>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          <tr className="webui-table-row-content">
            <td>
              <WebUiInput
                type="number"
                inputSize="sm"
                min={1}
                max={4095}
                disabled={readonly}
                value={newVid}
                onChange={(e) => setNewVid(Number(e.target.value) % 4095)}
              />
            </td>
            <td>
              <WebUiInput
                inputSize="sm"
                disabled={readonly}
                value={newVidName}
                onChange={(e) => setNewVidName(e.target.value)}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <WebUiButton disabled={readonly} onClick={onAdd}>
          Add VLAN ID
        </WebUiButton>
      </div>
    </div>
  );
}
